// extracted by mini-css-extract-plugin
export var loadingSpinner = "_56-1";
export var standaloneTable = "_56-0";